<template>
  <div id="body">
    <div id="main">
      <img :src="require('@/assets/imgs/logo-black.png')" id="logo" @click="toHome()" />
      <article class="container">
        <div v-show="step == 0">
          <div>
            <h1>What kind of account type would you like to start</h1>
            <div class="plan-selection" style="display:flex;flex-direction: column;">
              <div>
                <input
                  type="radio"
                  class="option-input radio"
                  id="one"
                  value="Free"
                  v-model="accountType"
                />
                <label for="one">Guest Plan (Free)</label>
              </div>
              <div>
                <input
                  type="radio"
                  class="option-input radio"
                  id="two"
                  value="Starter"
                  v-model="accountType"
                />
                <label for="two">Premium plan (Starter, Pro)</label>
              </div>
              <div class="plan-info">
                <p>- Over 60,000 asset coverage across different asset classes</p>
                <p>- Realtime Stock Prices and News data</p>
                <p>- Comprehensive Fundamental Data series containing Company Financials, Insider Trading, Ownership Structure and etc</p>
                <p>- Realtime Futures & Commodities data available upon request</p>
              </div>
            </div>
          </div>
        </div>
        <div v-show="currentPanel === 'Create Account'">
          <CreateAccountForm ref="AccountForm"></CreateAccountForm>
        </div>
        <div v-show="currentPanel === 'Institution info'">
          <div id="skip" @click="validatePanelInfo">
            <p>skip</p>
          </div>
          <InstitutionInfoForm ref="InsitutionForm"></InstitutionInfoForm>
        </div>

        <div v-show="currentPanel === 'Plan Selection'">
          <h1>Plan Selection</h1>
          <div class="plan-selection-content">
            <div class="container">
              <ul
                style="display:flex;justify-content: space-between;margin-left: -75px; margin-right: -36px; "
              >
                <li>
                  <p>Starter</p>
                  <p>$199.00</p>
                </li>
                <li>
                  <p>Pro</p>
                  <p>$299.00</p>
                </li>
              </ul>
              <vue-slider v-model="value" :marks="mark" :tooltip="'none'" :interval="100"></vue-slider>
            </div>
            <div>
              <p>*Overage fees $1/100k credits</p>
            </div>
          </div>
        </div>

        <div v-show="currentPanel === 'Payment'">
          <PaymentForm ref="PaymentForm" :plan="chosenPlan"></PaymentForm>
        </div>

        <div v-show="currentPanel === 'Summary'">
          <div v-if="accountType == 'Free'">
            <h1>Welcome to Unibit</h1>
          </div>

          <div v-else class="summary-content">
            <h1>Summary</h1>
            <h2>Total Monthy Cost {{planCost}} + tax</h2>
            <p>Period {{new Date().toLocaleDateString('US')}} - {{nextMonth}}</p>
            <p>Subscriptions renew automatically each month. Cancel anytime.</p>
          </div>

          <div v-if="!loggedIn">
            <p
              style="font-size: 24px;font-weight: bold; margin-top:4rem; margin-bottom: 4rem"
            >Check your email for a link to finish signing up.</p>
            <br />
            <button class="btn color-btn resend-btn" @click="resendEmail()">Resend Email</button>
            <br />
          </div>
        </div>

        <div>
          <!-- button group does not exsit when current panel is last summary panel or current is the 
          first step : step 0 when create a new accout, step 1 (plan selectioin) when user logged in-->
          <div
            v-if="currentPanel !== 'Summary' && step>0 && !(step == 1 && loggedIn)"
            class="button-group"
          >
            <button
              @click="() => this.$store.commit('goToLastStep')"
              class="btn transparent-btn"
            >Back</button>
            <pulse-loader v-if="loading" :loading="loading" color="#f5a623" size="1rem"></pulse-loader>
            <button v-else @click="validatePanelInfo" class="btn color-btn">Continue</button>
          </div>
          <!-- Only show continue button when user at first panel: choose account type step 0 
          or choose plan type step 1 when user logged in-->
          <div
            v-if="step==0 || (step == 1 && loggedIn)"
            style="text-align: right; margin-right: 3rem;"
          >
            <button @click="validatePanelInfo" class="btn color-btn">Continue</button>
          </div>
          <div v-if="currentPanel === 'Summary'">
            <button
              v-if="loggedIn"
              @click="toDocumentation"
              style=" float: right;width: 250px;"
              class="btn color-btn"
            >Enter API Documentation</button>
          </div>

          <div
            v-if="step<=1 && !loggedIn"
            class="signin-info"
            style="margin-top:2rem; text-align: center;"
          >
            <p>
              Already have an account?
              <span @click="toSignInPage">Sign in</span>
            </p>
          </div>
        </div>
      </article>
      <nav v-show="!(accountType == 'Premium' && step == 5)">
        <img :src="require('@/assets/imgs/logo-black.png')" id="logo" @click="toHome()" />
        <div v-if="step > 0" class="side-menu">
          <!-- panel function locked if user never get to the panel before -->
          <p
            v-for="(panel, index) in menuList"
            :key="index"
            :class="{ 'left-border' : step >= index+1 , 'locked': farestStep < index+1}"
            @click="farestStep < index+1 ? '' : goToPanel(index+1)"
          >{{panel}}</p>
        </div>
      </nav>
    </div>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import CreateAccountForm from "@/components/form/create-account-form";
import InstitutionInfoForm from "@/components/form/institution-info-form";
import PaymentForm from "@/components/form/payment-form";
import VueSlider from "vue-slider-component";
import "./orange-slider.css";

export default {
  components: {
    CreateAccountForm,
    InstitutionInfoForm,
    PaymentForm,
    VueSlider,
    PulseLoader
  },

  computed: {
    accountType: {
      get() {
        return this.$store.getters.pickedAccount;
      },
      set(val) {
        this.$store.commit("setPickedAccount", val);
      }
    },

    value: {
      get() {
        return this.$store.getters.planValue;
      },
      set(val) {
        this.$store.commit("setPlanValue", val);
      }
    },

    chosenPlan() {
      // return this.$globalConstants.plan[this.value];
      if (this.value == 0) return "Starter";
      else if (this.value == 100) return "Pro";
      else return "ERR";
    },

    nextMonth() {
      return new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString(
        "US"
      );
    },

    planCost() {
      if (this.chosenPlan === "Starter") return "$199";
      else if (this.chosenPlan === "Pro") return "$299";
      else return "$0";
    },

    menuList() {
      if (this.loggedIn) {
        return ["Plan Selection", "Payment", "Summary"];
      }

      if (this.accountType == "Premium") {
        return [
          "Create Account",
          "Institution info",
          "Plan Selection",
          "Payment",
          "Summary"
        ];
      } else {
        return ["Create Account", "Institution info", "Summary"];
      }
    },

    currentPanel() {
      return this.menuList[this.step - 1];
      // return "Summary";
    },

    ...mapState({
      loggedIn: state => state.UserService.idToken !== null,
      step: state => state.UserService.formStep,
      farestStep: state => state.UserService.farestStep,
      formError: state => state.UserService.formError,
      loading: state => state.UserService.loading
    })
  },

  watch: {
    accountType() {
      this.$store.commit("resetFarestStep");
    }
  },

  mounted() {
    if (this.loggedIn) {
      this.$store.commit("goToStep", 1);
    } else {
      this.$store.commit("goToStep", 0);
    }
  },

  data() {
    return {
      mark: {
        "0": {
          label: "10M credits"
        },
        "100": {
          label: "30M credits"
        }
      }
    };
  },

  methods: {
    resendEmail() {
      console.log("[sign-page] resendEmail() starting....");
      // disable the resend button
      $(".resend-btn").addClass("disabled");

      // send the verify email
      fetch(this.$globalConstants.BASE_URL + "user/resendverifyemail", {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({
          email: this.$store.getters.userEmail
        })
      })
        .then(data => {
          if (data.status !== 200) {
            console.log("Request failed: ", data);
            this.$store.dispatch("notify", {
              info: "Resend Failed. Please try again later.",
              type: "error"
            });
          } else {
            console.log("Request success: ", data);
            this.$store.dispatch("notify", {
              info: "Email sent successfully.",
              type: "success"
            });
          }
        })
        .catch(err => {
          console.log("Request failed: ", err);
          this.$store.dispatch("notify", {
            info: "Resend Failed. Please try again later.",
            type: "error"
          });
        });
    },

    toHome() {
      this.$router.push({ name: "advertising-page" });
    },

    toSignInPage() {
      this.$router.push({ name: "signin-page" });
    },

    toDocumentation() {
      this.$router.replace("/docs/V2.0/introduction");
    },

    goToPanel(step) {
      this.$store.commit("goToStep", step);
    },

    validatePanelInfo() {
      const step = this.step;
      const panel = this.currentPanel;

      switch (panel) {
        case "Create Account":
          this.$refs.AccountForm.validateSignUpForm();
          break;
        case "Institution info":
          if (this.accountType === "Free") {
            this.$refs.InsitutionForm.createFreeAccount();
          }
          break;
        case "Payment":
          if (this.loggedIn) {
            this.$refs.PaymentForm.updatePremiumPlan();
          } else {
            this.$refs.PaymentForm.createPremiumAccount();
          }

          break;
      }

      if (!this.formError && !this.loading) {
        this.$store.commit("goToNextStep");
      }
    }
  }
};
</script>



<style scoped>
* {
  box-sizing: border-box;
  font-family: Jura;
}
#body {
  background: url("../../assets/imgs/curveline.png") no-repeat center fixed;
  background-size: cover;
  /* background-color: rgba(255, 255, 255, 0.4);
  background-blend-mode: lighten; */
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
}
#main {
  display: flex;
  flex: 1;
  flex-direction: column;
}
#main > article {
  flex: 1;
}
#main > nav {
  background: transparent;
}

#main > nav {
  order: -1;
}

#main > nav {
  display: none;
}

#main > img {
  margin-top: 1rem;
}

#logo {
  margin-left: 3rem;
  width: 10rem;
  height: 36px;
}

#logo:hover {
  cursor: pointer;
}

p span {
  color: #f5a623;
  text-decoration: underline;
}

p > span:hover {
  cursor: pointer;
}

.plan-selection {
  margin-top: 3rem;
}

.plan-selection label {
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.71px;
  padding: 2rem 1rem;
  color: #4a4a4a;
}

.plan-info {
  margin-left: 4rem;
  width: 650px;
}

.plan-info > p {
  margin: 5px 0;
}
/* css for Radio input */

/* @keyframes click-wave {
  0% {
    height: 40px;
    width: 40px;
    opacity: 0.35;
    position: relative;
  }
  100% {
    height: 200px;
    width: 200px;
    margin-left: -80px;
    margin-top: -80px;
    opacity: 0;
  }
} */

.option-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;

  -o-appearance: none;
  appearance: none;
  position: relative;
  top: 13.33333px;
  right: 0;
  bottom: 0;
  left: 0;
  height: 40px;
  width: 40px;
  transition: all 0.15s ease-out 0s;
  background: #ffffff;
  border: none;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  margin-right: 0.5rem;
  outline: none;
  position: relative;
  border: solid 1px #f5a623;
  z-index: 1000;
}
.option-input:hover {
  background: #ffffff;
}
.option-input:checked {
  background: #f5a623;
}
.option-input:checked::before {
  height: 40px;
  width: 40px;
  position: absolute;
  content: "\02143";
  transform: rotate(40deg);
  display: inline-block;
  font-size: 26.66667px;
  text-align: center;
  line-height: 40px;
}
.option-input:checked::after {
  -webkit-animation: click-wave 0.65s;
  -moz-animation: click-wave 0.65s;
  animation: click-wave 0.65s;
  background: #f5a623;
  content: "";
  display: block;
  position: relative;
  z-index: 100;
}
.option-input.radio {
  border-radius: 50%;
}
.option-input.radio::after {
  border-radius: 50%;
}

.side-menu {
  text-align: center;
  height: 68vh;
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.side-menu > p {
  height: 32px;
  font-family: Jura;
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.71px;
  color: #4a4a4a;
  width: 300px;
  padding-top: 1rem;
  cursor: pointer;
  flex: 1;
}

.locked {
  color: #979797 !important;
  cursor: not-allowed !important;
}

.left-border {
  border-left: solid 4px #16abbd;
}

.side-menu:hover {
  cursor: pointer;
}

.icon:hover {
  cursor: pointer;
}

#skip {
  position: absolute;
  top: 1rem;
  right: 5rem;
  font-size: 24px;
  font-weight: bold;
  color: #f5a623;
}

#skip:hover {
  cursor: pointer;
  text-decoration: underline;
}

article {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.plan-selection-content {
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.plan-selection-content p {
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
  font-size: 20px;
}

.summary-content {
  height: 60vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.summary-content > h2 {
  height: 40px;
  font-size: 32px;
  font-weight: bold;
  color: #16abbd;
}

.summary-content > p {
  font-size: 20px;
  color: #4a4a4a;
}

.disabled {
  pointer-events: none;
}

h1 {
  font-family: Jura;
  font-size: 48px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.41px;
  /* margin-top: 5rem; */
  color: #4a4a4a;
}

.name-input-group {
  justify-content: space-between;
}

/* .name-input-group > label {
    width: 45%;
} */

header,
footer,
article,
nav,
aside {
  padding: 1em;
}

li {
  display: inline;
}
li > p {
  font-size: 20px;
  padding: 10px;
}

.button-group {
  display: flex;
  justify-content: space-between;
}

.btn {
  width: 174px;
  margin: 0px 2px;
  height: 40px;
  border-radius: 4px;
}

.transparent-btn {
  background-color: transparent;
  border: 1px solid #f5a623;
  color: #f5a623;
}

.transparent-btn:hover {
  background-color: #f5a623;
  color: white;
  font-weight: bold;
}

.color-btn {
  color: black;
  background: #f5a623;
  font-weight: bold;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.47px;
  color: #ffffff;
}

.signin-info {
  font-weight: bold;
  font-size: 20px;
}

@media screen and (min-width: 768px) {
  .container {
    padding: 3rem 2rem;
  }
}

@media screen and (min-width: 992px) {
  #main {
    flex-direction: row;
  }

  #main > img {
    display: none;
  }

  #main > nav {
    display: initial;
  }

  .container {
    padding: 3rem 4rem;
  }

  #main > nav {
    flex: 0 1 40vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/static/sign-page.vue